import XIcon from '@mui/icons-material/Close';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Translate } from 'react-localize-redux';
import ExternalLink from '../../resources/icons/externalLink.svg';
import Checked from '../../resources/svg/checked_with_circle.svg';
import InfoIcon from '../../resources/svg/info.svg';
import Button, { BUTTON_TYPES } from '../atoms/Button';
import Icon, { IconSizes } from '../foundations/Icon';
import css from './WarningMessage.css';

const iconTypes = iconAlign => ({
    info: <InfoIcon className={classNames(css.typeIcon, css[iconAlign])} />,
    whiteInfo: <InfoIcon className={classNames(css.typeIcon, css[iconAlign])} />,
    error: <Icon name="info-triangle" size={IconSizes.SMALL} className={classNames(css.typeIcon, css[iconAlign])} />,
    warning: <Icon name="info-triangle" size={IconSizes.SMALL} className={classNames(css.typeIcon, css[iconAlign])} />,
    success: <Checked className={classNames(css.typeIcon, css[iconAlign])} />,
    externalLink: <ExternalLink className={css.typeIcon} />,
    permission: <Icon name="lock" size={IconSizes.SMALL} className={classNames(css.typeIcon, css[iconAlign])} />,
});

const WarningMessage = ({
    message = '',
    containerStyle = {
        display: 'flex',
    },
    show: propShow = null,
    type = 'warning',
    showIcon = true,
    textReplace = {},
    showTypeIcon = true,
    iconAlign = 'center',
    showSpacer = true,
    className = '',
    textAlignCenter = false,
    buttonAction = () => {},
    buttonText = '',
    buttonType = 'flat',
    textContainerClass = '',
    onClose = null,
}) => {
    const [show, setShow] = useState(true);

    const handleRemove = () => setShow(false);

    const useShow = propShow !== null ? propShow : show;

    return (
        <div
            className={classNames(className, css.container, { [css[type]]: type })}
            style={{
                ...containerStyle,
                display: useShow ? containerStyle.display : 'none',
            }}
        >
            {showTypeIcon ? (
                <>
                    {iconTypes(iconAlign)[type]}
                    {showSpacer && <div className={classNames(css.spacer, { [css.solid]: showSpacer })} />}
                </>
            ) : null}
            <div
                key={message}
                className={classNames(css.messageContainer, textContainerClass, {
                    [css.textAlignCenter]: textAlignCenter,
                })}
            >
                {typeof message === 'string' ? <Translate id={message} data={textReplace} /> : message}
            </div>
            {buttonText ? (
                <Button onClick={buttonAction} type={buttonType}>
                    <Translate id={buttonText} />
                </Button>
            ) : null}
            {showIcon ? <XIcon onClick={onClose !== null ? onClose : handleRemove} className={css.icon} /> : null}
        </div>
    );
};

WarningMessage.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    textReplace: PropTypes.objectOf(PropTypes.any),
    containerStyle: PropTypes.objectOf(PropTypes.any),
    className: PropTypes.string,
    show: PropTypes.bool,
    showIcon: PropTypes.bool,
    type: PropTypes.oneOf(['error', 'warning', 'info', 'success', 'whiteInfo', 'externalLink']),
    showTypeIcon: PropTypes.bool,
    iconAlign: PropTypes.oneOf(['top', 'center', 'bottom']),
    showSpacer: PropTypes.bool,
    textAlignCenter: PropTypes.bool,
    buttonText: PropTypes.string,
    buttonAction: PropTypes.func,
    textContainerClass: PropTypes.string,
    onClose: PropTypes.func,
    buttonType: PropTypes.oneOf(BUTTON_TYPES),
};

export default WarningMessage;
